import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import useTrackEvent from '../../utils/trackEvent';
import './styles.scss';

function HomeNew() {
  const [logo, setLogo] = useState<string | null>(null);
  const [welcomeText, setWelcomeText] = useState<(string | JSX.Element)[] | string | null>(null);

  const trackEvent = useTrackEvent();
  useEffect(() => {
    trackEvent('PageView_Start', {});
  }, []);

  useEffect(() => {
    const defaultWelcomeText =
      'Met dit programma krijg je eenvoudig advies over hulpmiddelen die je kunt gebruiken om langer zelfstandig thuis te wonen. Door het beantwoorden van een aantal vragen krijg je vervolgens een advies.';
    if (window.customer) {
      setLogo(window.customer.logo_url);
      let text = window.customer.welcome_text !== null && window.customer.welcome_text.length > 0
        ? window.customer.welcome_text
        : defaultWelcomeText;
      const lines = text.split('\n');
      const welcomeTextArr: (string | JSX.Element)[] = new Array(lines.length * 2 - 1);
      for (let i = 0; i < lines.length; i++) {
        welcomeTextArr[i * 2] = lines[i];
        if (i !== 0) welcomeTextArr[i * 2 - 1] = <br key={i} />;
      }
      setWelcomeText(welcomeTextArr);
    } else {
      setLogo('/assets/images/logo.png');
      setWelcomeText(defaultWelcomeText);
    }
  }, []);

  return (
    <div className="background-header">
      <div className="site-container">
        <div className="sections space-y-5 lg:space-y-6">
          <section className="home-container">
            {logo && (
              <div className="tile-container">
                <div className="tile">
                  <h1 className="tile-title">Ondersteuning bij zelfstandig wonen</h1>
                  <div className="tile-text-container">
                    <p>Heb je ondersteuning nodig voor dagelijkse activiteiten?</p>
                    <p>Of help jij hier iemand mee?</p>
                    <p>Met deze vragenlijst krijg je eenvoudig advies over mogelijke hulpmiddelen.</p><br />
                    <p>Ik vul deze vragenlijst in als:</p>
                  </div>
                  <div className="flex flex-col lg:flex-row gap-4">
                    <Link to="/questions" className="button-primary" onClick={() => trackEvent('Click_StartButton', { option: 'Een client of patient' })}>
                      Een inwoner, cliënt of patiënt
                      <i className="fas fa-chevron-right"></i>
                    </Link>
                    <Link to="/questions" className="button-primary" onClick={() => trackEvent('Click_StartButton', { option: 'Een familielid of kennis' })}>
                      Een familielid, kennis of vrijwilliger
                      <i className="fas fa-chevron-right"></i>
                    </Link>
                    <Link to="/questions" className="button-primary" onClick={() => trackEvent('Click_StartButton', { option: 'Professional' })}>
                      Professional
                      <i className="fas fa-chevron-right"></i>
                    </Link>
                  </div>
                </div>
                <div className="tile">
                  <div className="logo-container">
                    <p>In samenwerking met:</p>
                    <img src={logo} alt="logo" />
                  </div>
                </div>
              </div>
            )}
          </section>
        </div>
      </div>
    </div>
  );
}

export default HomeNew;
